// extracted by mini-css-extract-plugin
export default {"global-search__bar":"styles_global-search__bar__hoIW6","global-search__advanced__search-results":"styles_global-search__advanced__search-results__c5s4V"};